import { actionTypes } from "../constants/toast";
import { toast } from "react-toastify";

const actions = {
  successToast: (msg) => (dispatch) => {
    toast.success(msg);
    dispatch({
      type: actionTypes.SUCCESS,
      payload: { msg },
    });
  },
  errorToast: (msg) => (dispatch) => {
    toast.error(msg);
    dispatch({
      type: actionTypes.ERROR,
      payload: { msg },
    });
  },
  warningToast: (msg) => (dispatch) => {
    toast.warn(msg);
    dispatch({
      type: actionTypes.WARNING,
      payload: { msg },
    });
  },
  infoToast: (msg) => (dispatch) => {
    toast.info(msg);
    dispatch({
      type: actionTypes.INFO,
      payload: { msg },
    });
  },
};

export { actions };
